// Hide "The prices you are seeing are before your discount" message
(function() {
  'use strict';
  
  // Search through all text nodes and elements
  function searchAndHide(node) {
    const textToFind = [
      'The prices you are seeing are before your discount',
      'prices you are seeing are before your discount',
      'before your discount',
      'prices are before your discount'
    ];
    
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent.trim();
      for (let searchText of textToFind) {
        if (text.includes(searchText)) {
          // Hide the parent element
          let parent = node.parentElement;
          if (parent) {
            parent.style.display = 'none';
            parent.style.visibility = 'hidden';
            parent.style.opacity = '0';
          }
          return true;
        }
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // Check element's text content
      const text = node.textContent.trim();
      for (let searchText of textToFind) {
        if (text.includes(searchText)) {
          node.style.display = 'none';
          node.style.visibility = 'hidden';
          node.style.opacity = '0';
          return true;
        }
      }
      
      // Recursively search child nodes
      for (let child of node.childNodes) {
        if (searchAndHide(child)) {
          return true;
        }
      }
    }
    return false;
  }
  
  // Function to hide elements containing specific text
  function hideDiscountMessage() {
    // Search the entire document
    searchAndHide(document.body);
  }
  
  // Run immediately
  hideDiscountMessage();
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideDiscountMessage);
  }
  
  // Run periodically to catch dynamically added content
  setInterval(hideDiscountMessage, 2000);
  
  // Run when new content is added (MutationObserver)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            searchAndHide(node);
          }
        });
      }
    });
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Also hide common discount message containers
  function hideDiscountContainers() {
    const selectors = [
      '[class*="discount-notice"]',
      '[class*="discount-message"]',
      '[class*="price-notice"]',
      '[class*="price-message"]',
      '[class*="discount-popup"]',
      '[class*="discount-toast"]',
      '[class*="discount-alert"]',
      '[class*="discount-modal"]',
      '[data-discount]',
      '[data-price-notice]',
      '[data-discount-message]'
    ];
    
    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.style.display = 'none';
        element.style.visibility = 'hidden';
        element.style.opacity = '0';
      });
    });
  }
  
  // Run container hiding function
  hideDiscountContainers();
  setInterval(hideDiscountContainers, 1000);
  
})(); 